import React from "react";
import classNames from "classnames/bind";

import { Screen } from "components/Screen";
import { useStateManager } from "utils/useStateManager";

import styles from "./Agreement.module.css";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: () => void;
};

export const Agreement: React.FC<Props> = (props) => {
  const { linkInfo } = useStateManager();

  return (
    <Screen
      title="О персональных данных"
      buttonTitle="Подтверждаю согласие"
      onSubmit={props.onSubmit}
    >
      <div className={cx("inner")}>
        {linkInfo && (
          <div
            className={cx("text")}
            dangerouslySetInnerHTML={{
              __html: linkInfo?.consent,
            }}
          />
        )}
      </div>
    </Screen>
  );
};
